import userSettingApi from '@/api/user-setting/user-setting-api'

export default {
  namespaced: true,
  state: {
    local:{}
  },
  mutations: {
    addOrUpdateLocal(state, setting) {
      state.local[setting.id] = setting.value;
    }
  },
  actions: {
    async addOrUpdate(_, form) {
      try {
        await userSettingApi.addOrUpdate(form);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    addOrUpdateLocal({commit}, setting) {
      commit('addOrUpdateLocal', setting);
    },
    async fetch(_, {id, device}) {
      try {
        const response = await userSettingApi.fetch(id, device);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.resolve(null);
      }
    }
  }
}
